package one.healthium.data.user.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class AdditionalUserInfoDto(
    @SerialName("key") val key: String,
    @SerialName("text") val text: String? = null,
    @SerialName("alt_text") val altText: String? = null,
)
